import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import configFile from "../../../configFile";

export default class EnvService {
  constructor($http, $localStorage, $state, $q, EnvironmentConfig) {
    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$q = $q;
    this.EnvironmentConfig = EnvironmentConfig;
  }

  getEnv() {
    if (this.EnvironmentConfig.api && this.EnvironmentConfig.api.indexOf("api-eb.int.jobbleapp.com") !== -1) return "prod";
    return "dev";
  }

  getAPIEndPoint() {
    return this.EnvironmentConfig.api;
  }

  getJobsAPIEndPoint() {
    return this.EnvironmentConfig.jobs_api;
  }

  getElasticSearchEventsAPIEndPoint() {
    return this.EnvironmentConfig.elasticSearchJobsAPI;
  }

  getStripeKey() {
    return this.EnvironmentConfig.stripeKey;
  }

  getTransActionFee() {
    return 0.05;
  }

  getPubNubSubKey() {
    return this.EnvironmentConfig.pubnubSubKey;
  }

  getPubNubPubKey() {
    return this.EnvironmentConfig.pubnubPubKey;
  }

  getMapsKey() {
    return this.EnvironmentConfig.mapsKey;
  }

  getGTMKey() {
    return this.EnvironmentConfig.gtmKey;
  }
}

EnvService.$inject = ["$http", "$localStorage", "$state", "$q", "EnvironmentConfig"];



// WEBPACK FOOTER //
// ./client/app/services/env.js